import type LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

const describeAbout = (about: readonly LabeledValueView[]): string => {
	if (about.length === 0) {
		return 'Ne porte sur personne';
	}

	return `Porte sur : ${about.map((entry) => entry.label).join(', ')}`;
};

export default describeAbout;
